import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CrudService } from "./crud.service";
import {PaginationService} from './pagination.service';

@Injectable()
export class CancelReasonCategoryService extends PaginationService {
  constructor(protected http: HttpClient) {
    super(http, "cancel_reason_categories");
  }
}
